import React from 'react'
import { Link } from 'react-router-dom'

export default function PageTitle({ title, anotherLink, prevLink, homeLink, homePage, prevPage, currentLink, anotherPage }) {
    return <>
        <section className="page-title layer-overlay overlay-dark-9 section-typo-light bg-img-center" data-tm-bg-img="images/bg/bg1.jpg" style={{ backgroundImage: `url('images/bg/bg1.jpg')` }}>
            <div className="container pt-50 pb-50">
                <div className="section-content">
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <h2 className="title">{title}</h2>
                            <nav className="breadcrumbs" role="navigation" aria-label="Breadcrumbs">
                                <div className="breadcrumbs">
                                    <span><Link to={homeLink} rel="home">{homePage} </Link></span>
                                    {prevPage ? <> <span><i className="fa fa-angle-right"></i></span> <span><Link to={prevLink}>{prevPage}</Link></span>
                                    </> : ''}
                                    {anotherPage ? <> <span><i className="fa fa-angle-right"></i></span> <span><Link to={anotherLink}> {anotherPage}</Link></span></> : ''}
                                    <span><i className="fa fa-angle-right"></i></span>
                                    <span className="active"> <Link to={currentLink}>{title}</Link></span>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
}
